var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#32D583"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4168 36.1118C29.4168 37.6152 30.6356 38.834 32.1391 38.834H34.6668C36.2777 38.834 37.5835 37.5281 37.5835 35.9173C37.5835 34.3065 36.2777 33.0007 34.6668 33.0007H32.3335C30.7227 33.0007 29.4168 31.6948 29.4168 30.084C29.4168 28.4732 30.7227 27.1673 32.3335 27.1673H34.8613C36.3647 27.1673 37.5835 28.3861 37.5835 29.8895M33.5002 25.4173V27.1673M33.5002 38.834V40.584M45.1668 33.0007C45.1668 39.444 39.9435 44.6673 33.5002 44.6673C27.0568 44.6673 21.8335 39.444 21.8335 33.0007C21.8335 26.5573 27.0568 21.334 33.5002 21.334C39.9435 21.334 45.1668 26.5573 45.1668 33.0007Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#A6F4C5",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/Pricing.e31d3e199b7481cc8d0c70d4234620ca.svg";
export { ForwardRef as ReactComponent };